import { QueryList, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TabMenu as TabMenuBase } from 'prime-ng-old/tabmenu';
import { UiTemplateDirective } from '../shared';
import { UiMenuComponent } from '../menu';
import { take } from 'rxjs/operators';
import { UiIconsModule } from '../icons';
import { ChevronLeftIcon } from 'prime-ng-old/icons/chevronleft';
import { ChevronRightIcon } from 'prime-ng-old/icons/chevronright';
import { UiRouterLinkActivePathDirective } from '../router-link-active-path';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/router";
import * as i3 from "../icons/icon.component";
const _c0 = ["submenu"];
const _c1 = ["*"];
const _c2 = a0 => ({
  "p-tabmenu p-component": true,
  "p-tabmenu-scrollable": a0
});
const _c3 = (a0, a1, a2) => ({
  "p-tabmenuitem": true,
  "p-disabled": a0,
  "p-highlight": a1,
  "p-hidden": a2
});
const _c4 = a0 => ({
  "p-menuitem-link-active": a0
});
const _c5 = (a0, a1, a2) => ({
  $implicit: a0,
  index: a1,
  selected: a2
});
const _c6 = () => ({
  isActive: "p-menuitem-link-active",
  isInActivePath: "p-menuitem-link-active"
});
function UiTabMenuComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronLeftIcon");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function UiTabMenuComponent_Conditional_2_3_ng_template_0_Template(rf, ctx) {}
function UiTabMenuComponent_Conditional_2_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTabMenuComponent_Conditional_2_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTabMenuComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16, 3);
    i0.ɵɵlistener("click", function UiTabMenuComponent_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navBackward());
    });
    i0.ɵɵconditionalCreate(2, UiTabMenuComponent_Conditional_2_Conditional_2_Template, 1, 1, "ChevronLeftIcon");
    i0.ɵɵtemplate(3, UiTabMenuComponent_Conditional_2_3_Template, 1, 0, null, 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.previousIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.previousIconTemplate);
  }
}
function UiTabMenuComponent_For_9_Conditional_2_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 22);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("icon", item_r4.icon);
  }
}
function UiTabMenuComponent_For_9_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTabMenuComponent_For_9_Conditional_2_Conditional_2_Conditional_0_Template, 1, 1, "ui-icon", 22);
    i0.ɵɵelementStart(1, "span", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵconditional(item_r4.icon ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.label);
  }
}
function UiTabMenuComponent_For_9_Conditional_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTabMenuComponent_For_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19, 5);
    i0.ɵɵconditionalCreate(2, UiTabMenuComponent_For_9_Conditional_2_Conditional_2_Template, 3, 2);
    i0.ɵɵtemplate(3, UiTabMenuComponent_For_9_Conditional_2_ng_container_3_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "ui-menu", 21, 6);
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const item_r4 = ctx_r6.$implicit;
    const ɵ$index_20_r6 = ctx_r6.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c4, ctx_r1.openedSubmenuIndex === item_r4.tabindex));
    i0.ɵɵattribute("tabindex", item_r4.tabindex ? item_r4.tabindex : "0")("target", item_r4.target)("title", item_r4.title)("id", item_r4.id);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.itemTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(14, _c5, item_r4, ɵ$index_20_r6, ctx_r1.activeItem == item_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("popup", true)("model", item_r4.items)("alignRight", ɵ$index_20_r6 + 1 >= ctx_r1.model.length ? true : false)("alignRightOffset", 8);
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 22);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("icon", item_r4.icon);
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getItemProp(item_r4, "label"));
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 26);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.getItemProp(item_r4, "label"), i0.ɵɵsanitizeHtml);
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", item_r4.badgeStyleClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getItemProp(item_r4, "badge"));
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Conditional_0_Template, 1, 1, "ui-icon", 22);
    i0.ɵɵconditionalCreate(1, UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Conditional_1_Template, 2, 1, "span", 23)(2, UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Conditional_2_Template, 1, 1, "span", 26);
    i0.ɵɵconditionalCreate(3, UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Conditional_3_Template, 2, 2, "span", 27);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵconditional(item_r4.icon ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r4.escape !== false ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(item_r4.badge ? 3 : -1);
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 24, 5);
    i0.ɵɵconditionalCreate(2, UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Conditional_2_Template, 4, 3);
    i0.ɵɵtemplate(3, UiTabMenuComponent_For_9_Conditional_3_Conditional_0_ng_container_3_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    const item_r4 = ctx_r6.$implicit;
    const ɵ$index_20_r6 = ctx_r6.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("target", ctx_r1.getItemProp(item_r4, "target"));
    i0.ɵɵattribute("href", ctx_r1.getItemProp(item_r4, "url"), i0.ɵɵsanitizeUrl)("id", ctx_r1.getItemProp(item_r4, "id"))("tabindex", !!ctx_r1.disabled(item_r4) ? "test" : 0)("aria-disabled", ctx_r1.disabled(item_r4))("aria-label", ctx_r1.getItemProp(item_r4, "label"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.itemTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(9, _c5, item_r4, ɵ$index_20_r6, ctx_r1.activeItem == item_r4));
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 22);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("icon", item_r4.icon);
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getItemProp(item_r4, "label"));
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 26);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.getItemProp(item_r4, "label"), i0.ɵɵsanitizeHtml);
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", item_r4.badgeStyleClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getItemProp(item_r4, "badge"));
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Conditional_0_Template, 1, 1, "ui-icon", 22);
    i0.ɵɵconditionalCreate(1, UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Conditional_1_Template, 2, 1, "span", 23)(2, UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Conditional_2_Template, 1, 1, "span", 26);
    i0.ɵɵconditionalCreate(3, UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Conditional_3_Template, 2, 2, "span", 27);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵconditional(item_r4.icon ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r4.escape !== false ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(item_r4.badge ? 3 : -1);
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 25, 5);
    i0.ɵɵconditionalCreate(2, UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Conditional_2_Template, 4, 3);
    i0.ɵɵtemplate(3, UiTabMenuComponent_For_9_Conditional_3_Conditional_1_ng_container_3_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    const item_r4 = ctx_r6.$implicit;
    const ɵ$index_20_r6 = ctx_r6.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", item_r4.routerLink)("queryParams", item_r4.queryParams)("routerLinkActivePath", i0.ɵɵpureFunction0(17, _c6))("target", item_r4.target)("fragment", item_r4.fragment)("queryParamsHandling", item_r4.queryParamsHandling)("preserveFragment", item_r4.preserveFragment)("skipLocationChange", item_r4.skipLocationChange)("replaceUrl", item_r4.replaceUrl)("state", item_r4.state);
    i0.ɵɵattribute("id", ctx_r1.getItemProp(item_r4, "id"))("tabindex", !!ctx_r1.disabled(item_r4) ? "test" : 0)("aria-disabled", ctx_r1.disabled(item_r4))("aria-label", ctx_r1.getItemProp(item_r4, "label"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.itemTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(18, _c5, item_r4, ɵ$index_20_r6, ctx_r1.activeItem == item_r4));
  }
}
function UiTabMenuComponent_For_9_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTabMenuComponent_For_9_Conditional_3_Conditional_0_Template, 4, 13, "a", 24);
    i0.ɵɵconditionalCreate(1, UiTabMenuComponent_For_9_Conditional_3_Conditional_1_Template, 4, 22, "a", 25);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional(!item_r4.routerLink ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r4.routerLink ? 1 : -1);
  }
}
function UiTabMenuComponent_For_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 18, 4);
    i0.ɵɵlistener("click", function UiTabMenuComponent_For_9_Template_li_click_0_listener($event) {
      const item_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.itemClick($event, item_r4));
    })("keydown", function UiTabMenuComponent_For_9_Template_li_keydown_0_listener($event) {
      const ctx_r4 = i0.ɵɵrestoreView(_r3);
      const item_r4 = ctx_r4.$implicit;
      const ɵ$index_20_r6 = ctx_r4.$index;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onKeydownItem($event, ɵ$index_20_r6, item_r4));
    })("focus", function UiTabMenuComponent_For_9_Template_li_focus_0_listener() {
      const item_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMenuItemFocus(item_r4));
    });
    i0.ɵɵconditionalCreate(2, UiTabMenuComponent_For_9_Conditional_2_Template, 6, 18);
    i0.ɵɵconditionalCreate(3, UiTabMenuComponent_For_9_Conditional_3_Template, 2, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(item_r4.styleClass);
    i0.ɵɵproperty("ngStyle", item_r4.style)("ngClass", i0.ɵɵpureFunction3(8, _c3, ctx_r1.getItemProp(item_r4, "disabled"), ctx_r1.isActive(item_r4), item_r4.visible === false));
    i0.ɵɵattribute("data-p-disabled", ctx_r1.disabled(item_r4))("data-p-highlight", ctx_r1.focusedItemInfo() === item_r4);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.isSubmenuToggle(item_r4) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isSubmenuToggle(item_r4) ? 3 : -1);
  }
}
function UiTabMenuComponent_Conditional_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronRightIcon");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-hidden", true);
  }
}
function UiTabMenuComponent_Conditional_12_3_ng_template_0_Template(rf, ctx) {}
function UiTabMenuComponent_Conditional_12_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTabMenuComponent_Conditional_12_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTabMenuComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28, 7);
    i0.ɵɵlistener("click", function UiTabMenuComponent_Conditional_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navForward());
    });
    i0.ɵɵconditionalCreate(2, UiTabMenuComponent_Conditional_12_Conditional_2_Template, 1, 1, "ChevronRightIcon");
    i0.ɵɵtemplate(3, UiTabMenuComponent_Conditional_12_3_Template, 1, 0, null, 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.previousIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.nextIconTemplate);
  }
}
export let UiTabMenuComponent = /*#__PURE__*/(() => {
  class UiTabMenuComponent extends TabMenuBase {
    constructor() {
      super(...arguments);
      this.openedSubmenuIndex = -1;
      this.activeSubmenu = signal(null, ...(ngDevMode ? [{
        debugName: "activeSubmenu"
      }] : /* istanbul ignore next */[]));
    }
    openSubmenu(event, menu, item) {
      const tabindex = parseInt(item.tabindex, 10);
      this.openedSubmenuIndex = tabindex;
      this.activeSubmenu.set({
        item,
        menu
      });
      menu.toggle(event);
      menu.onHide.pipe(take(1)).subscribe(() => {
        if (this.openedSubmenuIndex === tabindex) this.openedSubmenuIndex = -1;
        this.activeSubmenu.set(null);
      });
    }
    // NOTE: tabmenu implements advanced/custom keyboard navigation bindings.
    // using TAB, only the first element can be selected, then arrow keys must be used to reach other menu items.
    // not sure how thisj should be working ideally.
    // disabled for now, allowing to focus all items with tab.
    onTabKeyDown(tabLinks) {
      // tabLinks.forEach((item) => {
      //     item.nativeElement.tabIndex = DomHandler.getAttribute(item.nativeElement.parentElement, 'data-p-highlight') ? '0' : '-1';
      // });
    }
    itemClick(event, item) {
      if (this.isSubmenuToggle(item)) {
        if (this.submenu.length !== 1) {
          throw new Error('No or multiple submenus were found. currently tabmenu supports only use of exactly 1 submenu!');
        }
        this.openSubmenu(event, this.submenu.first, item);
        this.activeItem = item;
        this.tabChanged = true;
        this.cd.markForCheck();
      } else {
        super.itemClick(event, item);
      }
    }
    isSubmenuToggle(item) {
      return item.items?.length > 0;
    }
    isActive(item) {
      return false;
      if (item.routerLink) {
        const routerLink = Array.isArray(item.routerLink) ? item.routerLink : [item.routerLink];
        const router = this.router;
        const route = this.route;
        return router.isActive(router.createUrlTree(routerLink, {
          relativeTo: route
        }).toString(), item.routerLinkActiveOptions?.exact ?? item.routerLinkActiveOptions ?? false);
      }
      return item === this.activeItem;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiTabMenuComponent_BaseFactory;
        return function UiTabMenuComponent_Factory(__ngFactoryType__) {
          return (ɵUiTabMenuComponent_BaseFactory || (ɵUiTabMenuComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiTabMenuComponent)))(__ngFactoryType__ || UiTabMenuComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiTabMenuComponent,
        selectors: [["ui-tabMenu"]],
        contentQueries: function UiTabMenuComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        viewQuery: function UiTabMenuComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.submenu = _t);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c1,
        decls: 13,
        vars: 10,
        consts: [["content", ""], ["navbar", ""], ["inkbar", ""], ["prevBtn", ""], ["tab", ""], ["tabLink", ""], ["submenu", ""], ["nextBtn", ""], [3, "ngClass", "ngStyle"], [1, "p-tabmenu-nav-container"], ["type", "button", "role", "navigation", "pRipple", "", 1, "p-tabmenu-nav-prev", "p-tabmenu-nav-btn", "p-link"], [1, "p-tabmenu-nav-content", 3, "scroll"], ["role", "menubar", 1, "p-tabmenu-nav", "p-reset"], ["role", "presentation", 3, "ngStyle", "class", "ngClass"], ["role", "none", 1, "p-tabmenu-ink-bar"], ["type", "button", "role", "navigation", "pRipple", "", 1, "p-tabmenu-nav-next", "p-tabmenu-nav-btn", "p-link"], ["type", "button", "role", "navigation", "pRipple", "", 1, "p-tabmenu-nav-prev", "p-tabmenu-nav-btn", "p-link", 3, "click"], [4, "ngTemplateOutlet"], ["role", "presentation", 3, "click", "keydown", "focus", "ngStyle", "ngClass"], [1, "p-menuitem-link", 3, "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["appendTo", "body", 3, "popup", "model", "alignRight", "alignRightOffset"], [1, "p-menuitem-icon", 3, "icon"], [1, "p-menuitem-text"], ["role", "menuitem", "pRipple", "", 1, "p-menuitem-link", 3, "target"], ["role", "menuitem", "pRipple", "", 1, "p-menuitem-link", 3, "routerLink", "queryParams", "routerLinkActivePath", "target", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state"], [1, "p-menuitem-text", 3, "innerHTML"], [1, "p-menuitem-badge", 3, "ngClass"], ["type", "button", "role", "navigation", "pRipple", "", 1, "p-tabmenu-nav-next", "p-tabmenu-nav-btn", "p-link", 3, "click"]],
        template: function UiTabMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
            i0.ɵɵconditionalCreate(2, UiTabMenuComponent_Conditional_2_Template, 4, 2, "button", 10);
            i0.ɵɵelementStart(3, "div", 11, 0);
            i0.ɵɵlistener("scroll", function UiTabMenuComponent_Template_div_scroll_3_listener($event) {
              return ctx.onScroll($event);
            });
            i0.ɵɵprojection(5);
            i0.ɵɵelementStart(6, "ul", 12, 1);
            i0.ɵɵrepeaterCreate(8, UiTabMenuComponent_For_9_Template, 4, 12, "li", 13, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelement(10, "li", 14, 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵconditionalCreate(12, UiTabMenuComponent_Conditional_12_Template, 4, 2, "button", 15);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2, ctx.scrollable))("ngStyle", ctx.style);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.scrollable && !ctx.backwardIsDisabled ? 2 : -1);
            i0.ɵɵadvance(4);
            i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledBy)("aria-label", ctx.ariaLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.focusableItems);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.scrollable && !ctx.forwardIsDisabled ? 12 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, RouterModule, i2.RouterLink, UiMenuComponent, UiIconsModule, i3.UiIconComponent, ChevronLeftIcon, ChevronRightIcon, UiRouterLinkActivePathDirective],
        styles: ["@layer primeng{.p-tabmenu-nav-container[_ngcontent-%COMP%]{position:relative}.p-tabmenu-scrollable[_ngcontent-%COMP%]   .p-tabmenu-nav-container[_ngcontent-%COMP%]{overflow:hidden}.p-tabmenu-nav-content[_ngcontent-%COMP%]{overflow-x:auto;overflow-y:hidden;scroll-behavior:smooth;scrollbar-width:none;overscroll-behavior:contain auto}.p-tabmenu-nav-btn[_ngcontent-%COMP%]{position:absolute;top:0;z-index:2;height:100%;display:flex;align-items:center;justify-content:center}.p-tabmenu-nav-prev[_ngcontent-%COMP%]{left:0}.p-tabmenu-nav-next[_ngcontent-%COMP%]{right:0}.p-tabview-nav-content[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.p-tabmenu-nav[_ngcontent-%COMP%]{display:flex;margin:0;padding:0;list-style-type:none;flex-wrap:nowrap}.p-tabmenu-nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer;-webkit-user-select:none;user-select:none;display:flex;align-items:center;position:relative;text-decoration:none;overflow:hidden}.p-tabmenu-nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus{z-index:1}.p-tabmenu-nav[_ngcontent-%COMP%]   .p-menuitem-text[_ngcontent-%COMP%]{line-height:1;white-space:nowrap}.p-tabmenu-ink-bar[_ngcontent-%COMP%]{display:none;z-index:1}.p-tabmenu-nav-content[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.p-tabmenuitem[_ngcontent-%COMP%]:not(.p-hidden){display:flex}}[_nghost-%COMP%]{display:block;--tabMenuItemPadding: 8px 10px}.p-tabmenu[_ngcontent-%COMP%]{border:0 none}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]{padding:0;background:var(--tabMenuBgColor);border-bottom:none}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]{position:static;border:none;border-color:var(--tabMenuBorderColor);background-color:var(--tabMenuitemBgColor);margin-right:0;margin-bottom:-1px;transition:background-color .3s,color .3s}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]   .p-menuitem-link[_ngcontent-%COMP%]{color:var(--tabMenuitemTextColor);padding:var(--tabMenuItemPadding);overflow:unset;display:flex;flex:1}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]   .p-menuitem-link[_ngcontent-%COMP%]   .p-menuitem-text[_ngcontent-%COMP%]{color:var(--tabMenuitemTextColor);margin-right:.5em}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]   .p-menuitem-link[_ngcontent-%COMP%]   .p-menuitem-icon[_ngcontent-%COMP%]{color:var(--tabMenuIconColor);margin-right:.5em}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]:not(.p-disabled):hover{background-color:var(--tabMenuHoverBgColor);border-color:var(--tabMenuHoverBorderColor)}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]:not(.p-disabled):hover   .p-menuitem-link[_ngcontent-%COMP%]   .p-menuitem-text[_ngcontent-%COMP%]{color:var(--tabMenuHoverTextColor)}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]:not(.p-disabled):hover   .p-menuitem-link[_ngcontent-%COMP%]   .p-menuitem-icon[_ngcontent-%COMP%]{color:var(--tabMenuIconHoverColor)}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]:not(.p-disabled)   .p-menuitem-link[_ngcontent-%COMP%]:focus:not(.p-menuitem-link-active){background-color:var(--focusColor)!important;border-color:var(--focusColor)!important}body.a11y-emphasize-focus[_nghost-%COMP%]   .p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]:not(.p-disabled)   .p-menuitem-link[_ngcontent-%COMP%]:focus.p-menuitem-link-active, body.a11y-emphasize-focus   [_nghost-%COMP%]   .p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]:not(.p-disabled)   .p-menuitem-link[_ngcontent-%COMP%]:focus.p-menuitem-link-active{outline:var(--a11yFocusedElementOutline)!important;outline-offset:-2px!important}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]   a.p-menuitem-link-active[_ngcontent-%COMP%], .p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem.p-highlight[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{background-color:var(--tabMenuActiveBgColor);border-color:var(--tabMenuActiveBorderColor)}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]   a.p-menuitem-link-active[_ngcontent-%COMP%]   .p-menuitem-link[_ngcontent-%COMP%]   .p-menuitem-text[_ngcontent-%COMP%], .p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem.p-highlight[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   .p-menuitem-link[_ngcontent-%COMP%]   .p-menuitem-text[_ngcontent-%COMP%]{color:var(--tabMenuActiveTextColor)}.p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem[_ngcontent-%COMP%]   a.p-menuitem-link-active[_ngcontent-%COMP%]   .p-menuitem-link[_ngcontent-%COMP%]   .p-menuitem-icon[_ngcontent-%COMP%], .p-tabmenu[_ngcontent-%COMP%]   .p-tabmenu-nav[_ngcontent-%COMP%]   .p-tabmenuitem.p-highlight[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   .p-menuitem-link[_ngcontent-%COMP%]   .p-menuitem-icon[_ngcontent-%COMP%]{color:var(--tabMenuActiveIconColor)}.p-tabmenu.adminbar[_ngcontent-%COMP%]{background:var(--backgroundSoftColor);padding:8px 20px 0}.a11y-no-distraction-mode[_nghost-%COMP%]   .p-tabmenu[_ngcontent-%COMP%]   .p-menuitem-icon[_ngcontent-%COMP%], .a11y-no-distraction-mode   [_nghost-%COMP%]   .p-tabmenu[_ngcontent-%COMP%]   .p-menuitem-icon[_ngcontent-%COMP%]{display:none}"],
        changeDetection: 0
      });
    }
  }
  return UiTabMenuComponent;
})();